export const REFRESH_WIDGET_DATA = 'REFRESH_WIDGET_DATA';
export const UPDATE_SESSION_ID = 'UPDATE_SESSION_ID';
export const REFRESH_SESSION_ID = 'REFRESH_SESSION_ID';